import { FC, HTMLAttributes } from "react";
import classes from "./GenericCard.module.less";

export interface GenericCardProps extends HTMLAttributes<HTMLDivElement> {
    type?: "info" | "success" | "warning" | "danger" | "primary" | "light";
    size?: "miniest" | "mini" | "small" | "middle" | "large" | "larger";
    radius?: "slightly" | "rounded";
    title?: string;
}

export const GenericCard: FC<GenericCardProps> = ({
    type = "info",
    size = "middle",
    radius = "rounded",
    className,
    children,
    title,
    ...restProps
}) => {
    const _className = [
        "generic-card",
        classes.genericCard,
        classes[`genericCard--${type}`],
        classes[`genericCard--${size}`],
        classes[`genericCard--${radius}`],
        className,
    ]
        .join(" ")
        .trim();

    return (
        <div {...restProps} className={_className}>
            {title && <div className={classes.header}>{title}</div>}
            {children}
        </div>
    );
};
